import * as React from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { /*useDispatch, */ useSelector } from "react-redux";
import Ppal from "./views/Ppal";
import Politica from "./views/Politica";
import Difusion from "./views/Difusion";
import AdminDifusion from "./views/AdminDifusion";
import Ingreso from "./views/Ingreso";
import LdD from "./views/ListadeDisponibilidad";
import DiasJefe from "./views/DiasJefe";
import Dias from "./views/Dias";
import Elementos from "./views/Elementos";
import Anticipos from "./views/Anticipos";
import Ntf from "./views/Ntf";
import EstadoVehiculo from "./views/EstadoVehiculo";
import Prueba from "./views/Prueba";

import { isAuth } from "./redux/selectors";

export default () => {
  const auth = useSelector((state) => isAuth(state));

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Ppal />} />
        <Route exact path="/prueba" element={<Prueba />} />
        <Route exact path="/politica" element={<Politica />} />
        <Route exact path="/ntf/:modo/:guid/:token?" element={<Ntf />} />
        <Route
          exact
          path="/ev/:modo/:guid/:token?"
          element={<EstadoVehiculo />}
        />
        <Route exact path="/difusion/:modo/:guid" element={<Difusion />} />
        <Route
          exact
          path="/ldd/:modo/:conductor/:ec/:token?"
          element={<LdD />}
        />
        <Route
          exact
          path="/diasjefe/:modo/:sigla/:token?"
          element={<DiasJefe />}
        />
        <Route exact path="/dias/:modo/:conductor/:token" element={<Dias />} />
        <Route
          exact
          path="/elementos/:modo/:conductor/:token?"
          element={<Elementos />}
        />
        <Route
          exact
          path="/anticipos/:modo/:conductor/:token?"
          element={<Anticipos />}
        />
        <Route
          path="/AdminDifusion"
          element={!auth ? <Ingreso /> : <AdminDifusion />}
        />
      </Routes>
    </BrowserRouter>
  );
};
